"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialCheckbox = exports.MaterialCheckboxUnstyled = void 0;
const material_ui_1 = require("material-ui");
const Checkbox_1 = require("material-ui/Checkbox");
const Form_1 = require("material-ui/Form");
const react_1 = require("react");
const React = require("react");
const core_1 = require("@material-ui/core"); // To defeat type widening.
const decorate = material_ui_1.withStyles(theme => core_1.createStyles({
    default: {},
    disabled: {
        pointerEvents: "unset"
    },
    checked: {
        color: "#18c273"
    }
}));
class MaterialCheckboxUnstyled extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleKeyDown = (event) => {
            // D-002.67 — do not intercept Tab; native order must reach sibling fields
            // (e.g. Amount to Apply / Notes on Patient Payment). Callers may still
            // supply onKeyDown for custom Enter handling.
            if (this.props.onKeyDown) {
                this.props.onKeyDown(event);
                return;
            }
            this.handleEnter(event);
        };
    }
    render() {
        const { classes, className, checked, disabled, indeterminate, label, value } = this.props;
        return (React.createElement(Form_1.FormControlLabel, { control: React.createElement(Checkbox_1.default, { checked: checked, classes: classes, className: className, value: value, onChange: this.props.onAction, onBlur: this.props.onBlur, onKeyDown: this.handleKeyDown, indeterminate: indeterminate, disabled: disabled }), label: label }));
    }
    handleEnter(event) {
        // Enter only — Tab (keyCode 9) must use browser default tab order.
        if (event.keyCode === 13) {
            const form = event.target.form;
            if (!form || !form.elements)
                return;
            const index = Array.prototype.indexOf.call(form, event.target);
            if (index < 0)
                return;
            const next = form.elements[index + 1];
            if (next && typeof next.focus === "function") {
                next.focus();
                event.preventDefault();
            }
        }
    }
}
exports.MaterialCheckboxUnstyled = MaterialCheckboxUnstyled;
exports.MaterialCheckbox = material_ui_1.withTheme()(decorate(MaterialCheckboxUnstyled));



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/checkbox/checkbox.tsx
// module id = 123
// module chunks = 0 1